//import Global from "../global";
import { eTrackingEventsGTM } from '../utils/enums';

function getCidValue() {
  const { __UAA_STATE__: windowsState } = window;
  const cid =
    (windowsState &&
      windowsState.userContext &&
      (windowsState.userContext.cid || null)) ||
    null;

  return cid !== null ? cid + '' : null;
}

export default {
  sendEventToGA: function(category, action, label) {
    if (
      typeof window !== 'undefined' &&
      window.dataLayer &&
      typeof window.ga === 'function'
    ) {
      window.ga('set', 'dimension23', getCidValue());
      window.dataLayer.push({
        event: eTrackingEventsGTM.gaEvent,
        category,
        action,
        label
      });
    }
  },

  setGTMStaticData: function(data) {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(data);
    }
  }
};
